export default {
  install (Vue) {
    Vue.directive('dbClick', {
      inserted (el, binding) {
        el.addEventListener('click', () => {
          if (!el.disabled) {
            el.disabled = true
            setTimeout(() => {
              el.disabled = false
            }, binding.value || 600)
          }
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/dbClick.js